import type { SnapshotGoal } from 'services/api/snapshotClient';

type SnapshotGoalUpdateListener = (goal: SnapshotGoal) => void;
type SnapshotCheckInRequestListener = () => void;

const listeners = new Set<SnapshotGoalUpdateListener>();
const checkInRequestListeners = new Set<SnapshotCheckInRequestListener>();

export const publishSnapshotGoalUpdate = (goal: SnapshotGoal) => {
  listeners.forEach((listener) => listener(goal));
};

export const subscribeToSnapshotGoalUpdates = (listener: SnapshotGoalUpdateListener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const requestSnapshotGoalCheckIn = () => {
  checkInRequestListeners.forEach((listener) => listener());
};

export const subscribeToSnapshotGoalCheckInRequests = (listener: SnapshotCheckInRequestListener) => {
  checkInRequestListeners.add(listener);
  return () => {
    checkInRequestListeners.delete(listener);
  };
};
